import useMe from 'Jsx/Shared/Hooks/useMe';
import getQueryParam from 'Jsx/Utils/getQueryParam';
import useIsClient from 'Jsx/Shared/Hooks/useIsClient';

interface UseCanEnrollWithFirstEnrollResult {
  canEnrollToCourseFreemium: boolean;
  source: string;
}

function getTrialSource(value?: string) {
  return !value || value === 'true' ? 'external' : value;
}

const useCanEnrollWithFirstEnroll = (): UseCanEnrollWithFirstEnrollResult => {
  const { me, loading } = useMe();
  const isClient = useIsClient();
  const canEnrollFreemium = me && me?.canEnrollFreemium;
  const temporalParam = getQueryParam('temporal');
  const canEnrollToCourseFreemium =
    !loading &&
    ((temporalParam && canEnrollFreemium) || (temporalParam && !me));

  if (!isClient) {
    return {
      canEnrollToCourseFreemium: false,
      source: getTrialSource(temporalParam),
    };
  }

  return {
    canEnrollToCourseFreemium,
    source: getTrialSource(temporalParam),
  };
};

export default useCanEnrollWithFirstEnroll;
